// eslint-disable-next-line no-restricted-imports
import { extendTailwindMerge, twJoin, validators } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    override: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        validators.isArbitraryLength,
                        {
                            heading: [validators.isTshirtSize],
                            body: [validators.isTshirtSize],
                        },
                    ],
                },
            ],
        },
    },
});
export { twJoin, twMerge };
//# sourceMappingURL=twMerge.js.map